import { useAuthStore } from '@/stores';
import configfile from "@/config";

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (url, body, file = false) => {
        let urls = new URL(url);
        const requestOptions = {
            method,
            headers: authHeader(url),
        //    mode: 'no-cors',
        };
        if (body) {
            if(method == 'GET'){
                requestOptions.headers['Content-Type'] = 'application/json';
                urls.search = new URLSearchParams(body);
            }
            else if(method == 'POST' && file === false)
            {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.body = JSON.stringify(body);
            }
            else if(method == 'POST' && file === true)
            {
                requestOptions.body = body;
                //console.log(requestOptions);
            }

        }
        return fetch(urls, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const { user } = useAuthStore();
    const isLoggedIn = !!user?.access_token;
    const isApiUrl = url.startsWith(configfile.apiUrl);
    
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${user.access_token}` };
    } else {
        return {};
    }
}

async function handleResponse(response) {
    const isJson = response.headers?.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : null;

    // check for error response
    if (!response.ok) {
        const { user, logout } = useAuthStore();
        
        if ([401, 403].includes(response.status) && user) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            logout();
        }

        // get error message from body or default to response status
        const error = (data) || response.status;
        return Promise.reject(error);
    }

    return data;
}
